import { render } from "./NewRefCampaign.vue?vue&type=template&id=4fa23b36&scoped=true"
import script from "./NewRefCampaign.vue?vue&type=script&lang=js"
export * from "./NewRefCampaign.vue?vue&type=script&lang=js"

import "./NewRefCampaign.vue?vue&type=style&index=0&id=4fa23b36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa23b36"]])

export default __exports__